import Modal from 'react-modal';

import { sanitizeBlockHtml } from '@/lib/sanitize';

export type ImageLightboxProps = {
  isOpen: boolean;
  url: string;
  alt: string;
  caption?: string;
  onClose: () => void;
};

export function ImageLightbox({
  isOpen,
  url,
  alt,
  caption,
  onClose,
}: ImageLightboxProps) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      ariaHideApp={false}
      className="image-lightbox"
      overlayClassName="image-lightbox__overlay"
    >
      <button
        type="button"
        aria-label="Close"
        onClick={onClose}
        className="image-lightbox__close"
      >
        ✕
      </button>
      <img
        src={url}
        alt={alt}
        style={{
          maxWidth: '90vw',
          maxHeight: '85vh',
          display: 'block',
          margin: '0 auto',
        }}
      />
      {caption && (
        <div
          className="image-lightbox__caption"
          dangerouslySetInnerHTML={{ __html: sanitizeBlockHtml(caption) }}
        />
      )}
    </Modal>
  );
}
